import { AppEnvironmentEnum } from '@lib/shared';

export function hasDebugging(appEnvironment: AppEnvironmentEnum) {
	return appEnvironment !== AppEnvironmentEnum.LIVE;
}
